export default "__VITE_ASSET__Dx4FdD90__"